import Header from 'application/presentation/common/Header/Header'
import React, { useCallback } from 'react'
import cn from 'classnames'
import { Button } from 'application/presentation/common/uiComponents'

import s from './CareServicePage.module.scss'

const CareServicePage = () => {
  const onMailClickHandler = useCallback((e: any) => {
    e.preventDefault()
    window.location.href = 'mailto:moyservice@gmail.com'
  }, [])
  return (
    <>
      <Header title="Служба заботы" />
      <div className={s.content}>
        <div className={s.text}>
          Мы с радостью поможем с решением ваших вопросов онлайн в чате Telegram. <br />
          <br />
          Так же вы можете написать нам на почту:{' '}
          <a href="mailto:moyservice@gmail.com" onClick={onMailClickHandler}>
            moyservice@gmail.com
          </a>
        </div>
        <a
          href="mailto:moyservice@gmail.com"
          className={cn(s.btn, s.gray)}
          onClick={onMailClickHandler}
        >
          Написать на почту
        </a>
        <a href="https://t.me/MOYsupport" className={cn(s.btn, s.fiol)}>
          Написать в Telegram
        </a>
      </div>
    </>
  )
}

export default React.memo(CareServicePage)
